import React from 'react';
import { Box, Typography } from '@lucid/lego';
import styles from './Listing.module.scss';
import type { UserManagementUser } from '../utils';
import { useStore } from '../../../../store/store';

type ListingProps = {
  data: UserManagementUser[];
  userDetail: (user: UserManagementUser) => void;
  selectedUserId?: string;
};

/**
 * Listing component for displaying a list of users.
 * Shows user name and their assigned location.
 *
 * @component
 * @param {ListingProps} props - Component props
 * @returns {JSX.Element} User listing
 */
const Listing: React.FC<ListingProps> = ({ data, userDetail, selectedUserId }) => {
  const theme = useStore((state) => state.theme);

  return (
    <>
      {data?.map((user) => {
        const primaryLocation =
          user.locations.find((location) => location.isPrimary) ?? user.locations[0];

        return (
          <Box
            key={user.id}
            pb={16}
            pl={24}
            pr={24}
            pt={16}
            onClick={() => userDetail(user)}
            className={styles.cardBox}
            background={selectedUserId === user.id ? 'gray-6' : 'white'}
            theme={theme}
          >
            <Typography
              color={selectedUserId === user.id ? 'black' : 'white'}
              theme="light"
              size="medium"
              variant="h4"
            >
              {user.name}
            </Typography>
            <Typography
              size="small"
              variant="body"
              color={selectedUserId === user.id ? 'primary-2' : 'primary-1'}
              theme="light"
            >
              {primaryLocation?.name ?? '\u2014'}
            </Typography>
          </Box>
        );
      })}
    </>
  );
};

export default Listing;
